export const MONDAY_API_VERSION = '2023-10';
